<!--P027-->
<template>
  <div class="div_content">
    <div class="cs_margin_top_sm ui_hierarchy">
      <div class="cs_cursor_pointer ui_txt_hierarchy" @click="$router.push({name:'ShopManage'})">门店维护</div>
      <div class="ui_txt_hierarchy">&nbsp;>&nbsp;</div>
      <div class="cs_font_bold cs_cursor_pointer ui_txt_hierarchy">添加门店</div>
    </div>
    <div class="cs_margin_top div_search">
      <div class="cs_title_primary cs_text_default type_info_search">门店编号</div>
      <input v-model="search.shopNum" class="cs_input cs_radius_lg edtxt_info_search" placeholder="请输入">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">门店名称</div>
      <input v-model="search.shopName" class="cs_input cs_radius_lg edtxt_info_search" placeholder="请输入">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">品牌</div>
      <web-select :options="search.brandList"
                  @option-key="updateBrand"
                  v-model="search.brandName"
                  class="cs_input cs_radius_lg edtxt_info_search ui_margin_left_44"></web-select>
      <br>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm">负责人</div>
      <input v-model="search.contactName" class="cs_input cs_radius_lg edtxt_info_search cs_margin_top_sm ui_margin_left_30" placeholder="非必填">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm cs_margin_left">联系方式</div>
      <input v-model="search.mobileNo" class="cs_input cs_radius_lg edtxt_info_search cs_margin_top_sm" placeholder="非必填">
      <br>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm">所在地址</div>
      <input v-model="search.shopAddress" class="cs_input cs_radius_lg edtxt_info_search cs_margin_top_sm width_440" placeholder="非必填">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left cs_margin_top_sm">启用状态</div>
      <div class="cs_radius_lg txt_info_search cs_margin_top_sm" placeholder="请输入">启用</div>
    </div>
    <div class="div_operation_table cs_align_center" style="margin-top:400px;">
      <button @click="btnCancel" class="cs_btn cs_btn_sm ui_btn_ghost_blue"
              type="button">取消
      </button>
      <button @click="btnSave" class="cs_btn cs_btn_sm ui_btn_blue ui_margin_left_88"
              type="button">保存
      </button>
    </div>
    <div class="div_bottom"></div>
  </div>
</template>

<script>
  import WebSelect from "../../components/web-select"
  import WhParameter from "../../assets/csui/parameter/WhParameter"
  export default {
    name: "ShopAdd",
    components: {WebSelect},
    data: function () {
      return {
        search: {
          shopNum: "",
          shopName: "",
          contactName: "",
          mobileNo: "",
          shopAddress: "",
          brandList:[],
          brandId:"",
          brandName:"",
        },
      }
    },
    created: function () {
      this.showBrand();
    },
    mounted: function() {
    },
    methods: {
      showBrand(){
        this.$ajax.brand.list.bind(this)((data) => {
          //显示列表
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].brandName,
            })
          }
          this.search.brandList = array;
        }, (data) => {
        }, true)
      },
      updateBrand(key) {
        this.search.brandId = key;
      },
      btnSave(){
        try {
          WhParameter.verifyNotEmpty(this.search.shopNum, "门店编号");
          WhParameter.verifyNotEmpty(this.search.shopName, "门店名称");
        }catch (e) {
          this.$toast(e.message);
          return;
        }
        if(this.isEmptySelect(this.search.brandId)){
          this.$toast("请选择品牌");
          return;
        }
        this.$ajax.shop.addShop.bind(this)(this.search,(data) => {
          this.$toast("添加成功");
          this.$router.replace({name:'ShopManage'});
        }, (data) => {
        }, true)
      },
      btnCancel(){
        this.$router.go(-1);
      },
    },
  }
</script>

<style scoped>
.width_440{
  width: 440px;
}
</style>



// WEBPACK FOOTER //
// src/page/shop/ShopAdd.vue